export const CANVAS_ATTRIBUTE_MAP: Record<string, string> = {
	ssb_model_type: 'data-shed-type',
	ssb_model_type_version: 'data-shed-type-version',
	ssb_model_is_chicken_coop: 'data-shed-chicken-coop',
	ssb_model_hinge_type: 'data-model-hinge-type',
	ssb_model_roof_shape: 'data-model-roof-shape',
	ssb_model_roof_angle: 'data-model-roof-angle',
	ssb_model_roof_angle_lower: 'data-model-roof-angle-lower',
	ssb_model_roof_angle_upper: 'data-model-roof-angle-upper',
	ssb_model_size_error_value: 'data-model-size-error-value',
	ssb_model_enable_ar_feature: 'data-model-enable-ar',
	ssb_model_enable_railing: 'data-model-enable-railing',
	ssb_configurator_porch_is_active: 'data-model-enable-porch',
	porch_size_single_option: 'data-model-porch-size-single-option',
	porch_size_options: 'data-model-porch-has-size-options',
	external_porch: 'data-model-porch-external',
	horizontal_distributed: 'data-horizontal-distributed',
	horizontal_offset: 'data-horizontal-offset',
	min_spacing_horizontal_between_component: 'data-horizontal-spacing',
	ssb_model_set_price_manual: 'data-set-price-manual',
	ssb_model_enable_door_slab: 'data-enable-door-slab',
	enable_loft: 'data-enable-loft',
	side_gable: 'data-side-gable',
	ssb_configurator_upgrade_porch_custom_opening_size: 'data-porch-custom-opening-size',
	ssb_model_enable_brace: 'data-enable-brace',
	ssb_configurator_opening_available: 'data-opening-available-on',
	decking_direction: 'data-decking-direction',
	ssb_configurator_upgrade_porch_opening_size: 'data-porch-opening-size',
	ssb_configurator_tack_door: 'data-tack-door',
	ssb_model_second_floor_height: 'data-second-floor-height',
	ssb_allow_place_component_on_2nd_floor: 'data-place-place-component-on-2nd-floor',
	loft_height_from_top: 'data-loft-height-from-top',
	ssb_model_enable_vertical_distribute_component_on_porch_side:
		'data-enable-vertical-distribute-porch-size',
	ssb_model_porch_wraparound_siding: 'data-porch-wraparound-siding',
	ssb_configurator_enable_kick_board: 'is-enable-kick-board',
};

export const SHEDPRO_EXCLUDED_KEYS: string[] = ['shed_wall'];

export const DATA_MODEL_EXCLUDED_KEYS: string[] = [];
